import { render, staticRenderFns } from "./ViewReformDetail.vue?vue&type=template&id=b3203dde"
import script from "./ViewReformDetail.vue?vue&type=script&lang=js"
export * from "./ViewReformDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports